import type { ComboboxOption } from "../../types";
import type { Software } from "./type";

export const transformSoftwareToOption = (
  software: Software,
  disabledSoftwareIds: Set<string>,
): ComboboxOption => {
  const value = JSON.stringify({
    id: software.id,
    appIntegrationId: software.appIntegrationId,
  });
  return {
    value,
    label:
      software.name +
      (software.externalTenantName ? ` (${software.externalTenantName})` : ""),
    disabled: software.id
      ? disabledSoftwareIds.has(software.id)
      : software.appIntegrationId
        ? disabledSoftwareIds.has(software.appIntegrationId)
        : false,
  };
};
